import round from './round';

const breakCountdown = (nextSection, setState, finishedCallback) => {
  return round(
    1, // minutes
    60, // timeUnit
    `Get ready for ${nextSection}`,
    [],
    setState,
    finishedCallback
  )
};

export default breakCountdown;
